import ConcernSubstanceListsStep from './ConcernSubstanceListsStep.vue'
import { concernSubstanceListsDescriptor } from './descriptor'
import { createConcernSubstanceListsController } from './concern-substance-lists-controller'

const concernSubstanceListsStepImplementation = Object.freeze({
    descriptor: concernSubstanceListsDescriptor,
    component: ConcernSubstanceListsStep,
    createController: createConcernSubstanceListsController,
})

export {
    ConcernSubstanceListsStep,
    concernSubstanceListsDescriptor,
    createConcernSubstanceListsController,
    concernSubstanceListsStepImplementation,
}
